<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section v-if="loadData" class="widget-section q-mb-lg">
      <EnvRegistration
        :registrationId="registrationId"
        :registrationData="registrationData"
        :envs="envs"
        :existEnvironments="environments"
        mode="edit"
      />
    </section>
    <section v-if="loadData" class="widget-section">
      <div class="flex items-center">
        <span class="label-block">ADF Records:</span>
        <q-btn
          @click="showForm"
          flat
          no-caps
          class="q-ml-auto btn--no-hover text-weight-regular"
          round
          color="light-blue-5"
          size="15px"
          style="min-height: 30px"
          :ripple="false"
          :disabled="Boolean(createAdfError?.length)"
        >
          <q-tooltip v-if="createAdfError?.length">{{ createAdfError }}</q-tooltip>
          + Add record
        </q-btn>
      </div>
      <div v-if="showCreateForm">
        <div class="update-form">
          <q-banner v-if="generalErrors.length" class="text-white approval-error-banner q-mb-sm">
            <span class="flex items-center" v-for="(error, key) in generalErrors" :key="key">
              <q-icon name="error" class="q-mr-xs" size="16px"></q-icon>{{ error.message }}
            </span>
          </q-banner>
          <div class="flex full-width no-wrap">
            <JsonForms
              :renderers="renderers"
              :schema="schema"
              :data="formData"
              :uischema="uiSchema"
              :additionalErrors="createErrors"
              validationMode="ValidateAndShow"
              @change="validateForm"
            />
            <q-btn
              color="primary"
              size="md"
              class="q-ml-sm"
              :loading="loadSend"
              :disable="
                loadSend ||
                submitDisable ||
                Boolean(formErrors.length) ||
                Boolean(createErrors.length) ||
                Boolean(generalErrors.length)
              "
              style="height: 38px"
              @click="sendData()"
              no-caps
              label="Submit"
            ></q-btn>

            <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="closeForm">Cancel</q-btn>
          </div>
        </div>
      </div>
      <AdfWidget
        :registrationData="registrationData"
        :registrationId="registrationId"
        mode="edit"
        @confirmDeleteAdfRecord="confirmDeleteAdf"
      />
    </section>

    <q-dialog v-model="deleteAdfConfirm" class="single-service-page" persistent>
      <q-card style="min-width: 768px; border-radius: 0px">
        <q-toolbar class="shadow-2 q-py-sm q-px-md">
          <q-toolbar-title class="text-weight-bold">
            <strong>Confirm Delete ADF Record</strong>
          </q-toolbar-title>
          <q-btn icon="close" round flat class="btn--no-hover" @click="deleteAdfConfirm = false"></q-btn>
        </q-toolbar>
        <q-card-actions class="q-pb-md">
          <q-btn
            color="primary"
            size="md"
            class="q-ml-sm"
            @click="deleteAdf"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            no-caps
            label="Yes"
          ></q-btn>
          <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="deleteAdfConfirm = false"
            >No</q-btn
          >
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { JsonForms } from '@jsonforms/vue';
import emitter from 'tiny-emitter/instance';
import { getRegistration, getBluePrint, validateWorkFlow, createWorkFlow, subValWorkflow } from '../../api/api';
import EnvRegistration from '../EnvRegistration.vue';
import AdfWidget from '@/pages/digitalService/components/adf/AdfWidget.vue';
import { quasarRenderers } from '@/shared/jsonformsQuasarRenderers/renderers';

const renderers = [...quasarRenderers];

export default {
  name: 'RegistrationAdf',
  components: {
    AdfWidget,
    EnvRegistration,
    JsonForms,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
  },
  data() {
    return {
      envs: ['DEV', 'NONPROD', 'PROD'],
      environments: [],
      createAdfError: undefined,
      deleteAdfConfirm: false,
      loadData: false,
      deleteLoading: false,
      showCreateForm: false,
      formErrors: [],
      createErrors: [],
      generalErrors: [],
      loadSend: false,
      submitDisable: true,
      renderers: Object.freeze(renderers),
      validationTimeout: undefined,
      currentAdf: undefined,
      formData: {
        digitalServiceApmId: this.registrationData.digitalServiceApm,
        infraServiceApmId: this.registrationData.infrastructureServiceApm,
      },
      uiSchema: {
        type: 'Group',
        elements: [
          {
            type: 'HorizontalLayout',
            elements: [
              {
                type: 'Control',
                label: 'Object ID',
                scope: '#/properties/objectId',
              },
              {
                type: 'Control',
                label: 'Provider',
                scope: '#/properties/provider',
              },
              {
                type: 'Control',
                label: 'Environment',
                scope: '#/properties/environmentId',
              },
            ],
          },
        ],
      },
      schema: {},
    };
  },
  methods: {
    async validateForm(value) {
      this.formData = value.data;
      this.formErrors = value.errors;
      if (!value.errors.length && !this.createErrors.length) {
        this.formErrors = value.errors;

        this.loadSend = true;
        if (this.validationTimeout) clearTimeout(this.validationTimeout);
        this.validationTimeout = setTimeout(async () => {
          const workflowData = {
            workflowId: 'engprt.create-msbi-adf',
            inputVariables: this.formData,
          };
          try {
            await validateWorkFlow(workflowData);
            if (this.createErrors.length) {
              this.createErrors = [];
            }

            this.generalErrors = [];
            this.submitDisable = false;
          } catch (error) {
            if (error?.response?.data?.errors?.length) {
              //this.createErrors = error.response.data.errors.filter((error) => error.instancePath.length);
              this.generalErrors =
                error.response.data.errors.filter((error) => !error.instancePath.length && error.params?.toDisplay) ||
                [];
              if (!this.generalErrors.length) {
                this.$notify('negative', 'Error', error.message);
              }
            } else {
              this.$notify('negative', 'Error', error.message);
              if (this.createErrors.length) {
                this.createErrors = [];
              }
              this.generalErrors = [];
              clearTimeout(this.validationTimeout);
            }
            this.loadSend = true;
          } finally {
            this.loadSend = false;
          }
        }, 3000);
      }
    },
    closeForm() {
      this.formData = { digitalServiceApmId: this.registrationData.digitalServiceApm };
      this.showCreateForm = false;
    },
    confirmDeleteAdf(adf) {
      this.currentAdf = adf;
      this.deleteAdfConfirm = true;
    },
    async deleteAdf() {
      this.deleteLoading = true;
      const deleteZoneWorkflow = {
        workflowId: 'engprt.delete-msbi-adf',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          id: this.currentAdf.id,
          environment: this.currentAdf.environment,
        },
      };
      try {
        await createWorkFlow(deleteZoneWorkflow);
        this.$notify('positive', 'Success', 'ADF record will be deleted.');
        emitter.emit('reloadAdfRecords');
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.deleteLoading = false;
        this.currentZone = undefined;
        this.deleteZoneConfirm = false;
      }
    },
    async sendData() {
      try {
        const workflowData = {
          workflowId: 'engprt.create-msbi-adf',
          inputVariables: this.formData,
        };

        this.loadSend = true;
        await createWorkFlow(workflowData);
        this.$notify('positive', 'Success', 'ADF record will be created.');
        emitter.emit('reloadAdfRecords');
        this.closeForm();
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.loadSend = false;
      }
    },
    showForm() {
      this.showCreateForm = true;
    },
  },
  async mounted() {
    const { inputVariablesSchema: schema } = await getBluePrint('engprt.create-msbi-adf');
    delete schema.$async;
    delete schema.$schema;
    this.schema = schema;
    this.loadData = false;
    this.$showLoading();
    try {
      const dataPromise = getRegistration(this.registrationId, true, false).then(async (response) => {
        this.environments = response.environments.map((env) => ({ status: env.status, value: env.value, id: env.id }));
      });
      const subvalCreateAdf = {
        workflowId: 'engprt.create-msbi-adf',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          infraServiceApmId: this.registrationData.infrastructureServiceApm,
        },
        subSchemaId: 'add-button',
      };
      const subValPromise = subValWorkflow(subvalCreateAdf)
        .then(() => {
          this.createAdfError = undefined;
        })
        .catch((error) => {
          this.createAdfError = error.message;
        });
      await Promise.all([dataPromise, subValPromise]);
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
      this.$hideLoading();
    }
  },
};
</script>

<style lang="scss" scoped>
.env-form {
  width: 50%;
}
.label-block {
  font-size: 20px;
  font-weight: bold;
}
.widget-section {
  border-radius: 15px;
  background-color: white;
  padding: 30px;
}
</style>
